<template>
  <v-card :loading="loading">
    <v-card-title v-if="title">{{ title }}</v-card-title>
    <v-divider v-if="title"></v-divider>
    <v-card-text>
      <v-form v-model="form">
        <FormView v-model="value" :config="config" :states="states" />
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        v-if="canSave"
        text
        color="primary"
        @click="saveRow()"
        :disabled="!form || loading"
        >{{ t_save }}</v-btn
      >
      <v-btn
        v-if="canDelete && formMode != 'add'"
        text
        color="error"
        @click="deleteRow()"
        :disabled="loading"
        >{{ t_delete }}</v-btn
      >
      <v-btn v-if="canCancel" text color="error" @click="$emit('cancel')">{{
        t_cancel
      }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import server from "../../../services/server";
import FormView from "./FormView.vue";
import dataService from "../../../services/data";
import { mapGetters } from "vuex";

export default {
  name: "ApiDataForm",

  components: { FormView },

  props: [
    "dataApi",
    "modelApi",
    "queryApi",
    "insertApi",
    "updateApi",
    "deleteApi",
    "title",
    "filters",
    "formMode",
    "canSave",
    "canCancel",
    "canDelete",
    "states",
  ],

  data() {
    return {
      config: null,
      loading: false,
      value: {},
      form: false,
    };
  },

  mounted() {
    this.loadConfig();
  },

  watch: {
    modelApi() {
      this.loadConfig();
    },
    dataApi() {
      this.loadConfig();
    },
  },

  computed: {
    ...mapGetters(["t_save", "t_cancel", "t_delete"]),
  },

  methods: {
    refresh() {
      if (!this.config) return;

      if (this.formMode == "edit") {
        var api;
        if (this.queryApi) api = this.queryApi;
        else if (this.dataApi) api = this.dataApi + "/query";
        else return;

        this.loading = true;

        var filters;

        if (this.filters) {
          filters = dataService.buildFilter(this, this.filters, {});
        }

        server
          .post(api, { filters: filters })
          .then((response) => {
            if (response.rows.length > 0) this.value = response.rows[0];
            else this.value = {};
            this.loading = false;
          })
          .catch((err) => {
            alert(err);
            this.loading = false;
          });
      } else {
        this.value = dataService.getNewRowData(this.config);
      }
    },
    loadConfig() {
      var api;
      if (this.modelApi) api = this.modelApi;
      else if (this.dataApi) api = this.dataApi + "/model";
      else return;

      if (this.loading) return;
      this.loading = true;

      this.$store
        .dispatch("cache/getObject", { apiName: api })
        .then((response) => {
          this.config = response;
          this.loading = false;
          this.refresh();
        })
        .catch((err) => {
          alert(err);
          this.loading = false;
        });
    },
    beginLoad() {
      this.loading = true;
    },
    endLoad() {
      this.loading = false;
    },
    saveRow() {
      var api;

      var input = dataService.getFilterInputValue(this, this.filters, null);

      if (input) {
        for (var key in input) {
          this.value[key] = input[key];
        }
      }

      if (this.value[this.config.keyName]) {
        this.beginLoad();

        if (this.dataApi) {
          api = this.dataApi;
        } else {
          api = this.updateApi;
        }

        server
          .put(api, this.value[this.config.keyName], this.value)
          .then(() => {
            this.afterSave(this.value);
          })
          .catch((err) => {
            this.endLoad();
            alert(err);
          })
          .finally(() => this.endLoad());
      } else {
        this.beginLoad();

        if (this.dataApi) {
          api = this.dataApi;
        } else {
          api = this.insertApi;
        }

        server
          .post(api, this.value)
          .then((response) => {
            this.afterSave(response);
          })
          .catch((err) => {
            alert(err);
          })
          .finally(() => this.endLoad());
      }
    },
    afterSave(result) {
      if (result) {
        this.value = {};
        this.$emit("after-save", Object.assign({}, result));
      } else {
        this.$emit("after-save", this.value);
      }
    },
    deleteRow() {
      this.beginLoad();

      var api;

      if (this.dataApi) {
        api = this.dataApi;
      } else {
        api = this.deleteApi;
      }

      server
        .delete(api, this.value[this.config.keyName])
        .then(() => {
          this.endLoad();
          this.$emit("after-delete", this.value);
        })
        .catch((err) => {
          this.endLoad();
          alert(err);
        });
    },
  },
};
</script>